import { render, staticRenderFns } from "./PoiAddition.vue?vue&type=template&id=e012d6ac&scoped=true&"
import script from "./PoiAddition.vue?vue&type=script&lang=js&"
export * from "./PoiAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e012d6ac",
  null
  
)

export default component.exports